import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-voorheffingen',
  templateUrl: './voorheffingen.component.html',
  styleUrls: ['./voorheffingen.component.scss'],
})
export class VoorheffingenComponent {}
